import { PROFILE, BENEFITS } from "@/data/portfolio";
import Benefit from "@/components/site/Benefit";
import { T, useLang } from "@/lib/i18n";


export default function About() {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="border-t border-[#e5e0d8] section-pad bg-[#faf8f5]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="font-mono-label text-[11px] text-[#9a7218]">
              {t("01 · About me")}
            </div>
            <div className="mt-5 flex flex-wrap gap-2">
              {PROFILE.languages.map((l) => (
                <span
                  key={l.name}
                  data-testid={`about-lang-${l.name.toLowerCase()}`}
                  className="text-xs px-3 py-1 rounded-full bg-white border border-[#e5e0d8] text-[#14352a]"
                >
                  {t(l.name)} <span className="text-[#86928a] italic">· {t(l.level)}</span>
                </span>
              ))}
              <span className="text-xs px-3 py-1 rounded-full bg-[#14352a] text-[#faf8f5]">
                {PROFILE.location}
              </span>
            </div>
          </div>
          <div className="lg:col-span-8">
            <p className="text-base sm:text-lg text-[#14352a] leading-relaxed">
              {t(PROFILE.about.replace(/\s+/g, " "))}
            </p>
            <Benefit text={BENEFITS.about} testid="benefit-about" />
          </div>
        </div>
      </div>
    </section>
  );
}
